<script setup>
import {
  onMounted, ref, defineProps, defineEmits,
} from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { postReviewAPI, postMessage } from '../methods';

const props = defineProps({
  reviewData: {
    type: Object,
  },
  originReviewData: {
    type: Object,
  },
  reviewMethod: {
    type: String,
  },
});
const isLoading = ref(true);
const videoCourseId = ref(''); // 課程 ID
const emit = defineEmits(['changeStep', 'getData']);
const data = ref({
  whisperMethods: 'post',
  qustionList: [],
  content: '',
  originContent: '',
  submitLoading: false,
});

const getQuestionnairesHistory = async () => {
  const res = await axios.get(
    `/v1/video-courses/${videoCourseId.value}/review/options`,
  );
  if (res.data.whisper && res.data.whisper !== '') {
    data.value.content = res.data.whisper.content;
    data.value.originContent = res.data.whisper.content;
    data.value.whisperMethods = 'put';
  }
  if (res.data.questionnaires && res.data.questionnaires.length > 0) {
    const newArr = data.value.qustionList.map((q) => {
      const filter = res.data.questionnaires.filter((r) => r.item_id === q.id);
      if (filter.length > 0) {
        return {
          ...q,
          originRating: filter[0].rating,
          rating: filter[0].rating,
          httpMethod: 'put',
        };
      }
      return {
        ...q,
        rating: 0,
        httpMethod: 'post',
      };
    });
    data.value.qustionList = newArr;
  }
  isLoading.value = false;
};
const getQuestionnairesLsit = async () => {
  isLoading.value = true;
  try {
    const res = await axios.get(
      `/v1/review/video-courses/${videoCourseId.value}/questionnaires`,
    );
    const arr = [];
    res.data.questionnaires.forEach((item) => {
      arr.push({
        ...item,
        httpMethod: 'post',
      });
    });
    data.value.qustionList = arr;
    if (props.originReviewData.rating !== null) {
      getQuestionnairesHistory();
    } else {
      isLoading.value = false;
    }
  } catch (error) {
    // console.log(
    //   `something goes wrong, need to get data from another source: ${error}`,
    // );
    isLoading.value = false;
  }
};
const updateWhispers = (method, whisperData) => new Promise((resolve, reject) => {
  axios[method](
    `/v1/video-courses/${videoCourseId.value}/review/whispers`,
    whisperData,
  )
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    });
});
const updateQuestionnaires = (method, id, questionData) => new Promise((resolve, reject) => {
  axios[method](
    `/v1/video-courses/${videoCourseId.value}/review/questionnaires/${id}`,
    questionData,
  )
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    });
});
const submitAll = async () => {
  data.value.submitLoading = true;
  const reviewObj = {
    rating: props.reviewData.rating,
    content: props.reviewData.content,
  };
  try {
    await postReviewAPI(props.reviewMethod, videoCourseId.value, reviewObj);
    const updateAllPromise = [];
    if (data.value.content !== data.value.originContent) {
      updateAllPromise.push(
        updateWhispers(data.value.whisperMethods, {
          content: data.value.content === '' ? null : data.value.content,
        }),
      );
    }
    data.value.qustionList.forEach((q) => {
    // put: rating 存在，但和原始不同
    // post: rating 存在，沒有 originRating
      if (q.rating > 0 && (!q.originRating || q.rating !== q.originRating)) {
        updateAllPromise.push(
          updateQuestionnaires(q.httpMethod, q.id, { rating: q.rating }),
        );
      }
    });

    // 批次 array
    await Promise.all(updateAllPromise);
    if (props.reviewMethod === 'post') {
      emit('getData');
    }
    // console.log(results);
    data.value.submitLoading = false;
    emit('changeStep', 3);
  } catch (err) {
    const errorMessage = err?.response?.data?.message;
    const backToStep = errorMessage.includes('悄悄話') ? 2 : 1;
    emit('changeStep', backToStep);
    postMessage('danger', '評論回覆出現錯誤', `${err?.response?.data?.message}`);
    data.value.submitLoading = false;
  }
};
onMounted(() => {
  if (process.env.NODE_ENV === 'production') {
    videoCourseId.value = document.getElementById('video-course-id').textContent;
  } else {
    // eslint-disable-next-line prefer-destructuring
    videoCourseId.value = document
      .getElementById('lecture_heading')
      .dataset.lectureUrl.split('/')[2];
  }
  getQuestionnairesLsit();
});

// 悄悄話驗證
const commentValidate = () => {
  const tempComment = data.value.content;
  data.value.content = tempComment.replace(
    /[^a-zA-Z0-9\u4e00-\u9fa5\\_\\-\\.?!\\r\\n,.，！。？、 \n]/g,
    '',
  );
  if (data.value.content.length > 200) {
    data.value.content = data.value.content.slice(0, 200);
  }
};
</script>

<template>
  <div class="modal-body position-relative">
    <loading :active="data.submitLoading" :is-full-page="false" />
    <div class="mt-4 mb-2">
      <h4 class="text-center mb-4">想跟講師們說的悄悄話（選填）</h4>
      <div class="position-relative" style="min-height: 80px">
        <loading :active="isLoading" :is-full-page="false" />
        <div v-if="data.qustionList.length > 0">
          <div
            class="d-flex flex-wrap justify-content-between mb-2"
            v-for="q in data.qustionList"
            :key="`question_${q.id}`"
          >
            <div class="col-md-6">
              <p class="fw-bold" style="font-size: 16px">{{ q.question }}</p>
            </div>
            <div class="col-md-6 d-flex justify-content-end align-items-start">
              <div class="d-flex align-items-start">
                <p class="mb-0 me-2" style="font-size: 14px; margin-top: 2px">
                  完全不喜歡
                </p>
                <div
                  class="d-flex flex-column align-items-center"
                  v-for="n in 5"
                  :key="`question_${q.id}_check${n}`"
                >
                  <div class="form-check mb-0">
                    <input
                      class="form-check-input"
                      type="radio"
                      :name="`question_${q.id}`"
                      :id="`question_${q.id}_check${n}`"
                      :value="n"
                      v-model="q.rating"
                    />
                  </div>
                  <label
                    :for="`question_${q.id}_check${n}`"
                    class="pe-2"
                    style="font-size: 14px; margin-top: -5px"
                    >{{ n }}</label
                  >
                </div>
                <p class="mb-0" style="font-size: 14px; margin-top: 2px">
                  非常喜歡
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-2">
        <p class="mb-0 fw-normal">想跟講師說的悄悄話</p>
        <small class="text-muted"
          >僅能輸入數字、英文、中文字、標點符號（逗號、句號、驚嘆號、問號、頓號）</small
        >
        <div class="d-flex justify-content-end">
          <small class="text-muted"
            >{{ 200 - (data.content?.length || 0) }} / 200</small
          >
        </div>
        <textarea
          class="form-control"
          placeholder="謝謝老師的教導，以下是我的建議..."
          id=""
          rows="4"
          v-model="data.content"
          @keyup="commentValidate"
        ></textarea>
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <p class="mb-0 fw-normal">悄悄話內容並不會顯示於前台，請放心填寫！</p>
        <div>
          <button
            type="button"
            class="btn btn-outline-hex-review-dark border-transparent me-2"
            @click="$emit('submit')"
          >
            略過
          </button>
          <button
            type="button"
            class="btn btn-hex-review-dark"
            @click="submitAll"
          >
            完成並送出
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
